import { render } from "./AppHero.vue?vue&type=template&id=1a457aff&scoped=true"
import script from "./AppHero.vue?vue&type=script&lang=js"
export * from "./AppHero.vue?vue&type=script&lang=js"

import "./AppHero.vue?vue&type=style&index=0&id=1a457aff&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a457aff"]])

export default __exports__